const DashboardOverlay = () => {
	return <div className={`absolute left-0 top-16 right-0 bottom-10 z-10 bg-black/50`}></div>;
};

export default DashboardOverlay;
